import { render } from "./TopUpWalletForm.vue?vue&type=template&id=36556382"
import script from "./TopUpWalletForm.vue?vue&type=script&lang=js"
export * from "./TopUpWalletForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__